// ── ROOM GEOMETRY COLORMAP ────────────────────────────────────────────────────
// Default colormap key — user can change at runtime via the in-app dropdown.
// Diverging:  'PiYG' | 'PRGn' | 'BrBG' | 'PuOr' | 'RdGy' | 'RdBu' | 'RdYlBu' |
//             'RdYlGn' | 'Spectral' | 'coolwarm' | 'bwr' | 'seismic' |
//             'berlin' | 'managua' | 'vanimo'
// Sequential: 'viridis' | 'plasma' | 'inferno' | 'magma' | 'cividis'
export const DEFAULT_COLORMAP = 'viridis';

export const COLORMAPS = {
  // ── Diverging (ColorBrewer 11-stop) ────────────────────────────────────────
  PiYG: {
    // Pink → white → yellow-green
    stops: [[0,142,1,82],[0.1,197,27,125],[0.2,222,119,174],[0.3,241,182,218],[0.4,253,224,239],[0.5,247,247,247],[0.6,230,245,208],[0.7,184,225,134],[0.8,127,188,65],[0.9,77,146,33],[1,39,100,25]],
    accents: ['#C51B7D', '#7FBC41', '#276419'],
  },
  PRGn: {
    // Purple → white → green
    stops: [[0,64,0,75],[0.1,118,42,131],[0.2,153,112,171],[0.3,194,165,207],[0.4,231,212,232],[0.5,247,247,247],[0.6,217,240,211],[0.7,166,219,160],[0.8,90,174,97],[0.9,27,120,55],[1,0,68,27]],
    accents: ['#762A83', '#5AAE61', '#1B7837'],
  },
  BrBG: {
    // Brown → white → blue-green
    stops: [[0,84,48,5],[0.1,140,81,10],[0.2,191,129,45],[0.3,223,194,125],[0.4,246,232,195],[0.5,245,245,245],[0.6,199,234,229],[0.7,128,205,193],[0.8,53,151,143],[0.9,1,102,94],[1,0,60,48]],
    accents: ['#BF812D', '#80CDC1', '#35978F'],
  },
  PuOr: {
    // Orange → white → purple
    stops: [[0,127,59,8],[0.1,179,88,6],[0.2,224,130,20],[0.3,253,184,99],[0.4,254,224,182],[0.5,247,247,247],[0.6,216,218,235],[0.7,178,171,210],[0.8,128,115,172],[0.9,84,39,136],[1,45,0,75]],
    accents: ['#E08214', '#8073AC', '#2D004B'],
  },
  RdGy: {
    // Red → white → gray
    stops: [[0,103,0,31],[0.1,178,24,43],[0.2,214,96,77],[0.3,244,165,130],[0.4,253,219,199],[0.5,255,255,255],[0.6,224,224,224],[0.7,186,186,186],[0.8,135,135,135],[0.9,77,77,77],[1,26,26,26]],
    accents: ['#D6604D', '#BABABA', '#4D4D4D'],
  },
  RdBu: {
    // Red → white → blue
    stops: [[0,103,0,31],[0.1,178,24,43],[0.2,214,96,77],[0.3,244,165,130],[0.4,253,219,199],[0.5,247,247,247],[0.6,209,229,240],[0.7,146,197,222],[0.8,67,147,195],[0.9,33,102,172],[1,5,48,97]],
    accents: ['#D6604D', '#92C5DE', '#4393C3'],
  },
  RdYlBu: {
    // Red → yellow → blue
    stops: [[0,165,0,38],[0.1,215,48,39],[0.2,244,109,67],[0.3,253,174,97],[0.4,254,224,144],[0.5,255,255,191],[0.6,224,243,248],[0.7,171,217,233],[0.8,116,173,209],[0.9,69,117,180],[1,49,54,149]],
    accents: ['#D73027', '#FEE090', '#4575B4'],
  },
  RdYlGn: {
    // Red → yellow → green
    stops: [[0,165,0,38],[0.1,215,48,39],[0.2,244,109,67],[0.3,253,174,97],[0.4,254,224,139],[0.5,255,255,191],[0.6,217,239,139],[0.7,166,217,106],[0.8,102,189,99],[0.9,26,152,80],[1,0,104,55]],
    accents: ['#D73027', '#FEE08B', '#1A9850'],
  },
  Spectral: {
    // Red → yellow → teal → blue-purple
    stops: [[0,158,1,66],[0.1,213,62,79],[0.2,244,109,67],[0.3,253,174,97],[0.4,254,224,139],[0.5,255,255,191],[0.6,230,245,152],[0.7,171,221,164],[0.8,102,194,165],[0.9,50,136,189],[1,94,79,162]],
    accents: ['#D53E4F', '#66C2A5', '#3288BD'],
  },
  // ── Diverging (matplotlib native) ──────────────────────────────────────────
  coolwarm: {
    // Blue → light gray → red
    stops: [[0,59,76,192],[0.25,146,167,237],[0.5,221,221,221],[0.75,241,150,112],[1,180,4,38]],
    accents: ['#B40426', '#3B4CC0', '#92A7ED'],
  },
  bwr: {
    // Pure blue → white → pure red
    stops: [[0,0,0,255],[0.5,255,255,255],[1,255,0,0]],
    accents: ['#FF0000', '#0000FF', '#8888FF'],
  },
  seismic: {
    // Dark navy → blue → white → red → dark red
    stops: [[0,0,0,77],[0.25,0,0,255],[0.5,255,255,255],[0.75,255,0,0],[1,128,0,0]],
    accents: ['#FF0000', '#0000FF', '#800000'],
  },
  // ── Diverging (F. Cramér scientific-colour-maps, dark center) ──────────────
  berlin: {
    // Teal → black → orange (dark-center diverging)
    stops: [[0,157,213,218],[0.25,50,120,160],[0.5,10,10,10],[0.75,140,40,30],[1,232,183,130]],
    accents: ['#9DD5DB', '#C83218', '#E8B882'],
  },
  managua: {
    // Orange → black → cyan (dark-center diverging)
    stops: [[0,235,190,110],[0.25,145,80,20],[0.5,10,10,10],[0.75,20,90,130],[1,130,210,220]],
    accents: ['#EBB96E', '#148290', '#82D2DC'],
  },
  vanimo: {
    // Pink → black → green (dark-center diverging)
    stops: [[0,240,185,210],[0.25,160,50,100],[0.5,10,10,10],[0.75,30,110,70],[1,140,220,175]],
    accents: ['#E87BB2', '#1E6E46', '#8ADCAF'],
  },
  // ── Sequential (matplotlib) ─────────────────────────────────────────────────
  viridis: {
    // Dark purple → teal → green → yellow
    stops: [[0,68,1,84],[0.25,59,82,139],[0.5,33,145,140],[0.75,94,201,98],[1,253,231,37]],
    accents: ['#5DC863', '#21918C', '#3B528B'],
  },
  plasma: {
    // Dark purple → pink/red → yellow
    stops: [[0,13,8,135],[0.25,126,3,168],[0.5,204,71,120],[0.75,248,149,64],[1,240,249,33]],
    accents: ['#F89540', '#CC4778', '#7E03A8'],
  },
  inferno: {
    // Black → dark purple → crimson → orange → pale yellow
    stops: [[0,0,0,4],[0.25,87,16,110],[0.5,188,55,84],[0.75,249,142,9],[1,252,255,164]],
    accents: ['#F98C09', '#BC3754', '#57106E'],
  },
  magma: {
    // Black → dark purple → magenta/pink → salmon → pale yellow
    stops: [[0,0,0,4],[0.25,81,18,124],[0.5,183,55,121],[0.75,251,136,97],[1,252,253,191]],
    accents: ['#FB8861', '#B63679', '#51127C'],
  },
  cividis: {
    // Dark navy → gray/olive → yellow
    stops: [[0,0,32,77],[0.25,65,68,107],[0.5,124,111,119],[0.75,188,162,90],[1,254,232,71]],
    accents: ['#BCA25A', '#7E7875', '#00204D'],
  },
};

// Pre-parse accent hex colors once so the render loop never calls parseInt
Object.values(COLORMAPS).forEach(cm => {
  cm._pa = cm.accents.map(hex => [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ]);
});

export const COLORMAP_KEYS = Object.keys(COLORMAPS);

// Converts a hex color + alpha into an rgba(...) string
export function hexRgba(hex, a) {
  const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
  return `rgba(${r},${g},${b},${a})`;
}

// Bake a 256-entry RGB LUT for the given colormap key — O(1) pressure→color lookup
export function buildLUT(key) {
  const lut = new Uint8Array(256 * 3);
  const stops = COLORMAPS[key].stops;
  for (let i = 0; i < 256; i++) {
    const t = i / 255;
    for (let s = 1; s < stops.length; s++) {
      const [t0, r0, g0, b0] = stops[s - 1];
      const [t1, r1, g1, b1] = stops[s];
      if (t <= t1) {
        const f = (t - t0) / (t1 - t0);
        lut[i * 3]     = Math.round(r0 + (r1 - r0) * f);
        lut[i * 3 + 1] = Math.round(g0 + (g1 - g0) * f);
        lut[i * 3 + 2] = Math.round(b0 + (b1 - b0) * f);
        break;
      }
    }
  }
  return lut;
}

// Maps pressure p ∈ [-1,1] → [r,g,b] via a 256-entry LUT
export function applyColormap(p, lut) {
  const i = Math.round(Math.max(0, Math.min(255, (p + 1) / 2 * 255)));
  return [lut[i * 3], lut[i * 3 + 1], lut[i * 3 + 2]];
}

// Returns a CSS linear-gradient string for a colormap key (used by ColormapPicker)
export function colormapGradientCSS(key) {
  const stops = COLORMAPS[key].stops;
  const parts = stops.map(([t, r, g, b]) => `rgb(${r},${g},${b}) ${(t * 100).toFixed(1)}%`).join(', ');
  return `linear-gradient(to right, ${parts})`;
}

// Vertical variant for the pressure field colorbar (t=0 at bottom = low pressure, t=1 at top = high pressure)
export function colormapGradientVerticalCSS(key) {
  const stops = COLORMAPS[key].stops;
  const parts = stops.map(([t, r, g, b]) => `rgb(${r},${g},${b}) ${(t * 100).toFixed(1)}%`).join(', ');
  return `linear-gradient(to top, ${parts})`;
}
